import { Table, Layout, Image, Row, Col, Button, Modal, message, Carousel, Input, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import { ExclamationCircleOutlined, HeartOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import NewTable from "./components/NewTable";
import Carousel_news_ticker from './components/Carousel_news_ticker';
const { confirm } = Modal;
const FeedbackFormList = () => {
    const [total, set_total] = useState(1);
    const [request_list, set_request_list] = useState([]);
    const [request_list_modal, set_request_list_modal] = useState(false)
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([undefined, undefined])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [data, setData] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [default_column, set_default_column] = useState([
        {
            title: '需求修改單編號',
            key: 'name_serial',
            dataIndex: 'name_serial',
            align: 'center',
        },
        {
            title: '客戶名稱',
            key: 'user_name',
            dataIndex: 'user_name',
            align: 'center',
        },
        {
            title: '填表日期',
            key: 'first_insert_time',
            dataIndex: 'first_insert_time',
            align: 'center',
        },
        {
            title: '聯絡人',
            key: 'contact_person_name',
            dataIndex: 'contact_person_name',
            align: 'center',
        },
        {
            title: '客戶電話',
            key: 'contact_phone',
            dataIndex: 'contact_phone',
            align: 'center',
        },
        // {
        //     title: '圖片',
        //     sorter: false,
        //     render: (text, record, index) => (<>
        //         <div
        //             style={{
        //                 margin: 0,
        //                 maxHeight: '64px',
        //                 width: '64px',
        //             }}
        //         >
        //             {record['file_url'] ? record['file_url'].map((tmp, index) => (<>
        //                 <div>
        //                     <img width='64px' height={'auto'} src={tmp} />
        //                 </div>
        //             </>)) : null}
        //         </div>
        //     </>),
        // },
        {
            title: '需求列表',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (<>
                <Button type="primary" onClick={e => { set_request_list(record.feedback_request); get_picture_request_list(record.feedback_request); set_request_list_modal(true) }}>點擊查看</Button>
                {/* <Button type="text" style={{ color: 'red' }} onClick={(e) => showConfirm(record.key)}>刪除</Button> */}
            </>)
        },
        {
            title: '編輯',
            align: 'center',
            sorter: false,
            render: (text, record, index) => (<>
                {/* <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEdit(record.key)}>編輯</Button> */}
                <Button type="text" style={{ color: 'red' }} onClick={(e) => showConfirm(record.feedback_id)}>刪除</Button>
            </>)
        }
    ]);
    const getData = (param, sort, filter, checklist) => {
        // console.log(param);
        set_loading(true);
        return axios
            .get('/crmFeedBack/feedback', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    employment_time_start: search_date[0],
                    employment_time_end: search_date[1],
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                },
            })
            .then((response) => {
                set_total(response.data.total)
                setData(response.data.data);
                get_picture(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let feedback_id = value['feedback_id']
            // console.log(student_id);
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/crmFeedBack/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (feedback_id == value.feedback_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_picture_request_list = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let feedback_request_id = value['feedback_request_id']
            // console.log(student_id);
            console.log(value?.file_url?.length, value.file_id.length);
            if (value.file_id.length != 0 && value?.file_url?.length !== value.file_id.length) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/crmFeedBack/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            // console.log(dataurl)
                            set_request_list(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (feedback_request_id == value.feedback_request_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )
                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const showConfirm = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/crmFeedBack/feedback`, {
                data: [{ feedback_id: value }]
            })
            .then((response) => {
                if (response.data.status != undefined) {
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();

                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                }
            })

    }
    // useEffect(() => {
    //     if (extra_columns === null) {
    //         get_table_setting();
    //     } else {
    //         set_table_setting()
    //     }
    // }, [extra_columns])
    // const set_table_setting = () => {
    //     axios
    //         .post('/cramSchool/api/custom_table_setting', [
    //             {
    //                 table_name: 'feedback',
    //                 table_data: [
    //                     ...extra_columns.map(map_item => ({
    //                         column_key: map_item.key,
    //                         column_name: map_item.key
    //                     }))
    //                 ]
    //             }
    //         ])
    // }
    // const get_table_setting = () => {
    //     axios
    //         .get('/cramSchool/api/custom_table_setting', {
    //             params: {
    //                 custom_table_setting_table_name: 'feedback'
    //             }
    //         })
    //         .then(response => {
    //             set_extra_columns(response.data.map(map_item => ({
    //                 title: map_item.column_key,
    //                 key: map_item.column_key,
    //                 dataIndex: map_item.column_key,
    //             })))
    //         })
    // }
    useEffect(() => {
        getData();
    }, [])
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        reload()
    }, [search_date])
    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'feedback_id': value })
            })
            axios
                .delete(`/crmFeedBack/feedback`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    return (
        <>
            {contextHolder}
            <Modal
                style={{ pointerEvents: 'auto' }}
                width={800}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '20px' }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Table
                                    // bordered
                                    tableLayout={'fixed'}
                                    scroll={{ x: 'max-content' }}
                                    dataSource={request_list}
                                    columns={[
                                        /* {
                                            title: '需求修改項目',
                                            key: 'item',
                                            dataIndex: 'item',
                                            align: 'center',
                                        }, */
                                        {
                                            title: '修改原因',
                                            key: 'reason',
                                            dataIndex: 'reason',
                                            align: 'center',
                                        },
                                        /* {
                                            title: '驗收測試範例',
                                            key: 'accepting_test',
                                            dataIndex: 'accepting_test',
                                            align: 'center',
                                        }, */
                                        {
                                            title: '圖片',
                                            sorter: false,
                                            render: (text, record, index) => (<>
                                                <div
                                                    style={{
                                                        padding: 0,
                                                        margin: 'auto',
                                                        width: '150px',
                                                    }}
                                                >
                                                    <Carousel_news_ticker
                                                        file_url={record['file_url']}
                                                    />
                                                </div>
                                            </>),
                                        },
                                    ]}
                                    pagination={false}
                                />
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => set_request_list_modal(false)} block>返回</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </>}
                centered
                open={request_list_modal}
            ></Modal>
            <Row gutter={[0, 16]} style={{ paddingTop: '20px' }}>
                <Col span={24} style={{ paddingTop: '10px' }}>
                    <NewTable
                        total={total}
                        // extra_columns={extra_columns}
                        // set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'TeacherList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={data}//table資料
                        rowkey={'teacher_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        searchdate={true}
                        add={false}
                        rangepicker_title={'填表日期'}
                        handleSearchDate={handleSearchDate}//搜尋日期
                    ></NewTable>
                </Col>
            </Row>
        </>
    )
}
export default FeedbackFormList;
